import React, { useState, useEffect } from "react";
import { RiMenu3Line } from "react-icons/ri";
import { GiCrossMark } from "react-icons/gi";
import { BsFillMoonStarsFill } from "react-icons/bs";
import { useTheme } from "./ThemeContext";
import { FaAngleDoubleUp } from "react-icons/fa";
import Icon from "./Icon";
import "aos/dist/aos.css";
import AOS from "aos";
import { Link, useNavigate } from "react-router-dom";

const Navbar = () => {
    const [sticky, setSticky] = useState(false);
    const { isDarkMode, toggleDarkMode } = useTheme();
    const [showScrollButton, setShowScrollButton] = useState(false);
    const [open, setOpen] = useState(false);
    const [open1, setOpen1] = useState(false);
    // const [subMenuOpen, setSubMenuOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        AOS.init({
            duration: 500,
        });

        // Add smooth scrolling behavior
        document.documentElement.style.scrollBehavior = "smooth";
        const handleScroll = () => {
            if (window.scrollY > 0) {
                setSticky(true);
                setShowScrollButton(true);
            } else {
                setSticky(false);
                setShowScrollButton(false);
            }
        };
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            document.documentElement.style.scrollBehavior = "auto";
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const handleMenuItemClick = (link) => {
        setOpen(false); // Close the menu on mobile
        setOpen1(false);
        navigate(link); // Navigate to the specified link
    };

    const handleSubMenuClick = (link) => {
        setOpen1(false); // Close the submenu
        navigate(link); // Navigate to the specified link
    };

    const menuItems = [
        { name: "Home", link: "#home" },
        { name: "About", link: "#about" },
        // { name: "Courses", link: "#courses" },
        {
            name: "Tests",
            link: "#test",
            subMenus: [
                { name: "Mock Test", link: "/signup" },
                { name: "Weekly Test", link: "/signup" },
                { name: "Final Test", link: "/signup" },
            ],
        },
        { name: "Features" , link: "#features" },
        { name: "Team", link: "#team" },
        { name: "Contact Us", link: "#contact" },
    ];

    return (
        <div>
            <nav id="home" className={isDarkMode ? "dark" : ""}>
                <header
                    className={`bg-[#235191] dark:bg-zinc-800 self-stretch flex items-center justify-between top-0 p-4 px-10 md:px-20 lg:px-24 fixed left-0 z-20 right-0 ${sticky ? "bg-gray-900  opacity-85" : ""
                        }`}
                >
                    <div className={`flex gap-2 items-center z-[-1] `}>
                        <div>
                            <Icon />
                        </div>
                        <div className={`logo text-white font-bold mt-3 text-4xl max-md:max-w-full `}>
                            EntryHub
                        </div>
                        <BsFillMoonStarsFill
                            onClick={() => toggleDarkMode()}
                            className="cursor-pointer text-white ml-20"
                        />
                    </div>
                    <div className={`hidden lg:flex text-xl text-white  gap-8 `}>
                        {menuItems.map((item, index) => (
                            <div key={index}>
                                {item.subMenus ? (
                                    <div className="relative inline-block">
                                        <button
                                            onClick={() => setOpen1(!open1)}
                                            type="button"
                                            className="inline-flex justify-center hover:text-gray-400 duration-500 hover:scale-110"
                                        >
                                            {item.name}
                                        </button>
                                        {open1 && (
                                            <div
                                                data-aos="zoom-in"
                                                className="origin-top-right absolute right-0 mt-2 w-32 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5"
                                            >
                                                <div
                                                    className="py-1"
                                                    role="menu"
                                                    aria-orientation="vertical"
                                                    aria-labelledby="options-menu"
                                                >
                                                    {item.subMenus.map((subMenu, idx) => (
                                                        <Link
                                                            key={idx}
                                                            to={subMenu.link}
                                                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-100 rounded-lg"
                                                            onClick={() => handleSubMenuClick(subMenu.link)}
                                                        >
                                                            {subMenu.name}
                                                        </Link>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <a
                                        href={item.link}
                                        onClick={() => handleMenuItemClick(item.link)}
                                        className="hover:text-gray-400 duration-500 hover:scale-110"
                                    >
                                        {item.name}
                                    </a>
                                )}
                            </div>
                        ))}
                    </div>
                    <div className="lg:hidden">
                        {!open ? (
                            <div
                                onClick={() => setOpen(!open)}
                                className={`items-center flex z-30 cursor-pointer text-white text-xl right-10 top-6 `}
                            >
                                <RiMenu3Line />
                            </div>
                        ) : (
                            <GiCrossMark
                                onClick={() => setOpen(!open)}
                                className="text-white cursor-pointer top-10 right-10 md:right-20 fixed z-10"
                            />
                        )}
                        <div
                            className={`bg-[#235191] dark:bg-zinc-900 dark:text-stone-100 text-stone-100 text-center top-0 right-0 fixed w-96 h-full py-20 ${open ? "translate-x-0 " : "translate-x-full"
                                } ease-in-out ${open ? 'gap-8' : ''} duration-300`}
                        >
                            {menuItems.map((item, index) => (
                                <div key={index} className={`${open ? 'mb-6' : ''}`}>
                                    {item.subMenus ? (
                                        <div className="justify-center relative inline-block">
                                            <button
                                                onClick={() => setOpen1(!open1)}
                                                type="button"
                                                className="flex justify-center hover:text-gray-400 duration-500 hover:scale-110"
                                            >
                                                {item.name}
                                            </button>
                                            {open1 && (
                                                <div
                                                    data-aos="zoom-in"
                                                    className={`absolute -left-36 -top-1 w-32 rounded-md shadow-lg ${open ? "" : ""} bg-white ring-1 ring-black ring-opacity-5`}
                                                >
                                                    <div
                                                        className="py-1"
                                                        role="menu"
                                                        aria-orientation="vertical"
                                                        aria-labelledby="options-menu"
                                                    >
                                                        {item.subMenus.map((subMenu, idx) => (
                                                            <Link
                                                                key={idx}
                                                                to={subMenu.link}
                                                                className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-100 rounded-lg"
                                                                onClick={() => handleSubMenuClick(subMenu.link)}
                                                            >
                                                                {subMenu.name}
                                                            </Link>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <a
                                        href={item.link}
                                        onClick={() => handleMenuItemClick(item.link)}
                                        className="hover:text-gray-400 duration-500 hover:scale-110"
                                    >
                                        {item.name}
                                    </a>
                                    )}
                                </div>
                            ))}
                        </div>

                    </div>
                </header>
            </nav>

            {showScrollButton && (
                <div
                    className={`fixed bottom-10 right-10 bg-[#235191] border-4 z-10 border-[#3FE0A5] px-2 py-2 rounded-full cursor-pointer text-white ${sticky ? "opacity-100" : "opacity-0"
                        } transition-opacity duration-500`}
                    onClick={scrollToTop}
                >
                    <FaAngleDoubleUp />
                </div>
            )}
        </div>
    );
};

export default Navbar;
